import { render } from "./FormDrawerLabel.vue?vue&type=template&id=3b534f9d&scoped=true"
import script from "./FormDrawerLabel.vue?vue&type=script&lang=js"
export * from "./FormDrawerLabel.vue?vue&type=script&lang=js"

import "./FormDrawerLabel.vue?vue&type=style&index=0&id=3b534f9d&scoped=true&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b534f9d"]])

export default __exports__